<template>
  <div class="row px-2 py-3 width-100-p bg-me-primary border-color-light rounded-4"
    :style="$vuetify.display.width <= 768 ? 'margin-bottom: 20px;' : $vuetify.display.width < 1440 ? 'margin-bottom: 24px' : 'margin-bottom: 30px'"
      >
    <el-col :span="24">
      <div
        class="ma-0"
        v-loading="loading"
        :element-loading-spinner="svg"
        element-loading-svg-view-box="-10, -10, 50, 50"
        element-loading-background="rgba(122, 122, 122, 0.8)"
      >
        <h5 class="text-white mt-3 ml-5">Overlap per Charger</h5>
        <div class="custom-table-design">
          <el-table
            :data="paginatedperCharger"
            stripe
            :fit="true"
            height="300"
            :row-class-name="tableRowClassName"
            class="my-2 data-table"
            scrollbar-always-on: false
          >
            <el-table-column
              :label="'Charger ID'"
              :prop="'id'"
              :width="$vuetify.display.width <= 1200 ? 225 : ''"
              sortable
            />
            <el-table-column
              :label="convertLabelNames('charger_name')"
              :prop="'charger_name'"
              :width="$vuetify.display.width <= 1200 ? 225 : ''"
              sortable
            />
            <el-table-column
              :label="'Count per charger'"
              :prop="'count_per_charger'"
              :width="$vuetify.display.width <= 1200 ? 225 : ''"
              sortable
            >
            <template #default="scope">
              {{
              scope.row.count_per_charger == null
                  ? ""
                  : Number(scope.row.count_per_charger).toLocaleString()
              }}
            </template>
            </el-table-column>
            <el-table-column
              :label="'Usage per charger (kWh)'"
              :prop="'usage_kwh_per_charger'"
              :width="$vuetify.display.width <= 1200 ? 225 : ''"
              sortable
            >
            <template #default="scope">
              {{
              scope.row.usage_kwh_per_charger == null
                  ? ""
                  : Number(scope.row.usage_kwh_per_charger).toLocaleString()
              }}
            </template>
            </el-table-column>

          </el-table>
        </div>

        <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
          <el-row class="row-bg" justify="space-between">
            <el-col
              :span="5"
              class="d-flex justify-content-start align-items-center"
            >
              <el-select
                v-model="paginationParams.perCharger.perPageCount"
                placeholder="Select"
                size="small"
                style="width: 70px"
                @change="updatePageSize(type='perCharger', $event)"
              >
                        <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
              </el-select>
            </el-col>
            <el-col
              :span="8"
              class="d-flex align-items-center justify-content-center"
            >
              <el-pagination
                small
                background
                layout="prev, pager, next"
                :total="paginationParams.perCharger.total_items"
                v-model:page-size="paginationParams.perCharger.perPageCount"
                v-model:current-page="paginationParams.perCharger.current_page"
                @current-change="changePage(type='perCharger', $event)"
                class="my-4"
              />
            </el-col>
            <el-col :span="5" class="d-flex justify-content-end align-items-center">
              <span class="text-white">
                {{ ((paginationParams.perCharger.current_page - 1) * paginationParams.perCharger.perPageCount + 1).toLocaleString() }}-{{
                    paginationParams.perCharger.current_page * paginationParams.perCharger.perPageCount > paginationParams.perCharger.total_items
                      ? paginationParams.perCharger.total_items.toLocaleString()
                      : (paginationParams.perCharger.current_page * paginationParams.perCharger.perPageCount).toLocaleString()
                  }}
                  of {{ paginationParams.perCharger.total_items.toLocaleString() }}
              </span>
            </el-col>
          </el-row>
        </div>

        <div class="custom-pagination" v-if="$vuetify.display.width < 700">
          <el-row class="row-bg" justify="space-between">
            <el-col
              :span="24"
              class="d-flex align-items-center justify-content-center"
            >
              <el-pagination
                small
                background
                layout="prev, pager, next"
                :total="paginationParams.perCharger.total_items"
                v-model:page-size="paginationParams.perCharger.perPageCount"
                v-model:current-page="paginationParams.perCharger.current_page"
                @current-change="changePage(type='perCharger', $event)"
                class="my-4"
              />
            </el-col>
            <el-col
              :span="10"
              class="d-flex justify-content-end align-items-center"
            >
              <el-select
                v-model="paginationParams.perCharger.perPageCount"
                placeholder="Select"
                size="small"
                style="width: 70px"
                @change="updatePageSize(type='perCharger', $event)"
              >
                        <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
              </el-select>
            </el-col>
            <el-col :span="10" class="d-flex justify-content-start align-items-center">
              <span class="text-white">
                {{ ((paginationParams.perCharger.current_page - 1) * paginationParams.perCharger.perPageCount + 1).toLocaleString() }}-{{
                    paginationParams.perCharger.current_page * paginationParams.perCharger.perPageCount > paginationParams.perCharger.total_items
                      ? paginationParams.perCharger.total_items.toLocaleString()
                      : (paginationParams.perCharger.current_page * paginationParams.perCharger.perPageCount).toLocaleString()
                  }}
                  of {{ paginationParams.perCharger.total_items.toLocaleString() }}
              </span>
            </el-col>
          </el-row>
        </div>
      </div>

    </el-col>
  </div>

  <!-- All Overlaps -->
  <div class="row px-2 py-3 width-100-p bg-me-primary border-color-light rounded-4"
    :style="$vuetify.display.width <= 768 ? 'margin-bottom: 20px' : $vuetify.display.width < 1440 ? 'margin-bottom: 24px' : 'margin-bottom: 30px'"
    >
    <el-col :span="24">
      <div
        class="ma-0"
        v-loading="loading"
        :element-loading-spinner="svg"
        element-loading-svg-view-box="-10, -10, 50, 50"
        element-loading-background="rgba(122, 122, 122, 0.8)"
      >

        <h5 class="text-white mt-3 ml-5">All Overlaps</h5>
        <div class="custom-table-design">
          <el-table
            :data="paginatedAllOverlaps"
            stripe
            :fit="true"
            height="300"
            :row-class-name="tableRowClassName"
            class="my-2 data-table"
            scrollbar-always-on: false
          >
            <el-table-column
                :label="'ID'"
                :prop="'id'"
                :width="$vuetify.display.width <= 1200 ? 225 : ''"
                sortable
              />
            <el-table-column
              :label="convertLabelNames('start_time')"
              :prop="'start_time'"
              :width="$vuetify.display.width <= 1200 ? 225 : ''"
              sortable
            >
              <template #default="scope">
                {{ formatDate(scope.row.start_time, "YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>
            <el-table-column
              :label="convertLabelNames('end_time')"
              :prop="'end_time'"
              :width="$vuetify.display.width <= 1200 ? 225 : ''"
              sortable
            >
              <template #default="scope">
                {{ formatDate(scope.row.end_time, "YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>
            <el-table-column
              :label="'Usage (kWh)'"
              :prop="'usage_kWh'"
              :width="$vuetify.display.width <= 1200 ? 225 : ''"
              sortable
            >
            <template #default="scope">
              {{
              scope.row.usage_kWh == null
                  ? ""
                  : Number(scope.row.usage_kWh).toLocaleString()
              }}
            </template>
            </el-table-column>

          </el-table>
        </div>

        <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
          <el-row class="row-bg" justify="space-between">
            <el-col
              :span="5"
              class="d-flex justify-content-start align-items-center"
            >
              <el-select
                v-model="paginationParams.allOverlaps.perPageCount"
                placeholder="Select"
                size="small"
                style="width: 70px"
                @change="updatePageSize(type='allOverlaps', $event)"
              >
                           <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
              </el-select>
            </el-col>
            <el-col
              :span="8"
              class="d-flex align-items-center justify-content-center"
            >
              <el-pagination
                small
                background
                layout="prev, pager, next"
                :total="paginationParams.allOverlaps.total_items"
                v-model:page-size="paginationParams.allOverlaps.perPageCount"
                v-model:current-page="paginationParams.allOverlaps.current_page"
                @current-change="changePage(type='allOverlaps', $event)"
                class="my-4"
              />
            </el-col>
            <el-col :span="5" class="d-flex justify-content-end align-items-center">
              <span class="text-white">
                {{ ((paginationParams.allOverlaps.current_page - 1) * paginationParams.allOverlaps.perPageCount + 1).toLocaleString() }}-{{
                    paginationParams.allOverlaps.current_page * paginationParams.allOverlaps.perPageCount > paginationParams.allOverlaps.total_items
                      ? paginationParams.allOverlaps.total_items.toLocaleString()
                      : (paginationParams.allOverlaps.current_page * paginationParams.allOverlaps.perPageCount).toLocaleString()
                  }}
                  of {{ paginationParams.allOverlaps.total_items.toLocaleString() }}
              </span>
            </el-col>
          </el-row>
        </div>

        <div class="custom-pagination" v-if="$vuetify.display.width < 700">
          <el-row class="row-bg" justify="space-between">
            <el-col
              :span="24"
              class="d-flex align-items-center justify-content-center"
            >
              <el-pagination
                small
                background
                layout="prev, pager, next"
                :total="paginationParams.allOverlaps.total_items"
                v-model:page-size="paginationParams.allOverlaps.perPageCount"
                v-model:current-page="paginationParams.allOverlaps.current_page"
                @current-change="changePage(type='allOverlaps', $event)"
                class="my-4"
              />
            </el-col>
            <el-col
              :span="10"
              class="d-flex justify-content-end align-items-center"
            >
              <el-select
                v-model="paginationParams.allOverlaps.perPageCount"
                placeholder="Select"
                size="small"
                style="width: 70px"
                @change="updatePageSize(type='allOverlaps', $event)"
              >
                        <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
              </el-select>
            </el-col>
            <el-col :span="10" class="d-flex justify-content-start align-items-center">
              <span class="text-white">
                {{ ((paginationParams.allOverlaps.current_page - 1) * paginationParams.allOverlaps.perPageCount + 1).toLocaleString() }}-{{
                    paginationParams.allOverlaps.current_page * paginationParams.allOverlaps.perPageCount > paginationParams.allOverlaps.total_items
                      ? paginationParams.allOverlaps.total_items.toLocaleString()
                      : (paginationParams.allOverlaps.current_page * paginationParams.allOverlaps.perPageCount).toLocaleString()
                  }}
                  of {{ paginationParams.allOverlaps.total_items.toLocaleString() }}
              </span>
            </el-col>
          </el-row>
        </div>

      </div>
    </el-col>
  </div>
  <!-- All Overlaps end -->

  <!-- overlap pairs -->
  <div class="row px-2 py-3 width-100-p bg-me-primary border-color-light rounded-4"
    :style="$vuetify.display.width <= 768 ? 'margin-bottom: 20px' : $vuetify.display.width < 1440 ? 'margin-bottom: 24px' : 'margin-bottom: 30px'"
  >
      <el-col :span="24">
        <div
          class="ma-0"
          v-loading="loading"
          :element-loading-spinner="svg"
          element-loading-svg-view-box="-10, -10, 50, 50"
          element-loading-background="rgba(122, 122, 122, 0.8)"
        >

          <h5 class="text-white mt-3 ml-5">Overlap Pairs</h5>
          <div class="custom-table-design">
            <el-table
              :data="paginatedPairs"
              :fit="true"
              height="300"
              :row-class-name="tableRowClassName"
              stripe
              class="my-2 data-table"
              scrollbar-always-on: false
            >
              <el-table-column
                  :label="convertLabelNames('customer')"
                  :prop="'customer'"
                  :width="$vuetify.display.width <= 2031 ? 200 : ''"
                  sortable
              />
              <el-table-column
                  :label="convertLabelNames('site_name')"
                  :prop="'site_name'"
                  :width="$vuetify.display.width <= 2031 ? 200 : ''"
                  sortable
              />
              <el-table-column
                  :label="convertLabelNames('charger_name')"
                  :prop="'charger_name'"
                  :width="$vuetify.display.width <= 2031 ? 200 : ''"
                  sortable
              />
              <el-table-column
                  :label="'Charger ID'"
                  :prop="'charger_id'"
                  :width="$vuetify.display.width <= 2031 ? 200 : ''"
                  sortable
              />
              <el-table-column
                  :label="'Port ID'"
                  :prop="'port_id'"
                  :width="$vuetify.display.width <= 2031 ? 200 : ''"
                  sortable
              />
              <el-table-column
                :label="'Start Time (a)'"
                :prop="'start_time_a'"
                :width="$vuetify.display.width <= 2031 ? 180 : ''"
                sortable
              >
                <template #default="scope">
                  {{ formatDate(scope.row.start_time_a, "YYYY-MM-DD HH:mm:ss") }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'End Time (a)'"
                :prop="'end_time_a'"
                :width="$vuetify.display.width <= 2031 ? 180 : ''"
                sortable
              >
                <template #default="scope">
                  {{ formatDate(scope.row.end_time_a, "YYYY-MM-DD HH:mm:ss") }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Usage_a (kWh)'"
                :prop="'usage_kwh_a'"
                :width="$vuetify.display.width <= 2031 ? 160 : ''"
                sortable
              >
              <template #default="scope">
                {{
                scope.row.usage_kwh_a == null
                    ? ""
                    : Number(scope.row.usage_kwh_a).toLocaleString()
                }}
              </template>
            </el-table-column>
              <el-table-column
                :label="'Start Time (b)'"
                :prop="'start_time_b'"
                :width="$vuetify.display.width <= 2031 ? 180 : ''"
                sortable
              >
                <template #default="scope">
                  {{ formatDate(scope.row.start_time_b, "YYYY-MM-DD HH:mm:ss") }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'End Time (b)'"
                :prop="'end_time_b'"
                :width="$vuetify.display.width <= 2031 ? 180 : ''"
                sortable
              >
                <template #default="scope">
                  {{ formatDate(scope.row.end_time_b, "YYYY-MM-DD HH:mm:ss") }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Usage_b (kWh)'"
                :prop="'usage_kwh_b'"
                :width="$vuetify.display.width <= 2031 ? 160 : ''"
                sortable
              >
              <template #default="scope">
                {{
                scope.row.usage_kwh_b == null
                    ? ""
                    : Number(scope.row.usage_kwh_b).toLocaleString()
                }}
              </template>
            </el-table-column>

            </el-table>
          </div>

          <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
            <el-row class="row-bg" justify="space-between">
              <el-col
                :span="5"
                class="d-flex justify-content-start align-items-center"
              >
                <el-select
                  v-model="paginationParams.pairs.perPageCount"
                  placeholder="Select"
                  size="small"
                  style="width: 70px"
                  @change="updatePageSize(type='pairs', $event)"
                >
                            <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
                </el-select>
              </el-col>
              <el-col
                :span="8"
                class="d-flex align-items-center justify-content-center"
              >
                <el-pagination
                  small
                  background
                  layout="prev, pager, next"
                  :total="paginationParams.pairs.total_items"
                  v-model:page-size="paginationParams.pairs.perPageCount"
                  v-model:current-page="paginationParams.pairs.current_page"
                  @current-change="changePage(type='pairs', $event)"
                  class="my-4"
                />
              </el-col>
              <el-col :span="5" class="d-flex justify-content-end align-items-center">
                <span class="text-white">
                  {{ ((paginationParams.pairs.current_page - 1) * paginationParams.pairs.perPageCount + 1).toLocaleString() }}-{{
                    paginationParams.pairs.current_page * paginationParams.pairs.perPageCount > paginationParams.pairs.total_items
                      ? paginationParams.pairs.total_items.toLocaleString()
                      : (paginationParams.pairs.current_page * paginationParams.pairs.perPageCount).toLocaleString()
                  }}
                  of {{ paginationParams.pairs.total_items.toLocaleString() }}
                </span>
              </el-col>
            </el-row>
          </div>

          <div class="custom-pagination" v-if="$vuetify.display.width < 700">
            <el-row class="row-bg" justify="space-between">
              <el-col
                :span="24"
                class="d-flex align-items-center justify-content-center"
              >
                <el-pagination
                  small
                  background
                  layout="prev, pager, next"
                  :total="paginationParams.pairs.total_items"
                  v-model:page-size="paginationParams.pairs.perPageCount"
                  v-model:current-page="paginationParams.pairs.current_page"
                  @current-change="changePage(type='pairs', $event)"
                  class="my-4"
                />
              </el-col>
              <el-col
                :span="10"
                class="d-flex justify-content-end align-items-center"
              >
                <el-select
                  v-model="paginationParams.pairs.perPageCount"
                  placeholder="Select"
                  size="small"
                  style="width: 70px"
                  @change="updatePageSize(type='pairs', $event)"
                >
                        <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
                </el-select>
              </el-col>

              <el-col :span="10" class="d-flex justify-content-start align-items-center">
                <span class="text-white">
                  {{ ((paginationParams.pairs.current_page - 1) * paginationParams.pairs.perPageCount + 1).toLocaleString() }}-{{
                    paginationParams.pairs.current_page * paginationParams.pairs.perPageCount > paginationParams.pairs.total_items
                      ? paginationParams.pairs.total_items.toLocaleString()
                      : (paginationParams.pairs.current_page * paginationParams.pairs.perPageCount).toLocaleString()
                  }}
                  of {{ paginationParams.pairs.total_items.toLocaleString() }}
                </span>
              </el-col>
            </el-row>
          </div>

        </div>
      </el-col>
  </div>
  <!-- overlap pairs end -->
</template>

<script>
import { convertToTitleCase } from "../common/common-tools";
import moment from "moment";

export default {
  props: {
    loadingProp: {
      type: Boolean,
      default: false,
    },
    // usersDataProp: {
    //   type: Array,
    //   default(rawProps) {
    //     return rawProps;
    //   },
    // },
    usersDataProp: {
      type: Object,
      default(rawProps) {
        return rawProps;
      },
    },
    totalRowProp: {
      type: Number,
    },
  },
  components: {
    // ShowDetail,
  },
  data() {
    return {
      show: true,
      OverlapTableData: {
        OverlapPerCharger: [],
        AllOverlaps: [],
        OverlapPairs: [],
      },

      current_page: 1,
      page_size: 50,
      perPageCount: 50,
      loading: false,

      paginationParams: {
        pairs: {
          current_page: 1,
          page_size: 50,
          total_items: 0,
          perPageCount: 50,
        },
        allOverlaps: {
          current_page: 1,
          page_size: 50,
          total_items: 100,
          perPageCount: 50,
        },
        perCharger: {
          current_page: 1,
          page_size: 50,
          total_items: 100,
          perPageCount: 50,
        },
      },
    };
  },
  computed:{
    paginatedPairs(){
      const current_page = this.paginationParams.pairs.current_page;
      const perPageCount = this.paginationParams.pairs.perPageCount;
      const start = (current_page - 1) * perPageCount;
      const end = current_page * perPageCount;
      return this.OverlapTableData.OverlapPairs.slice(start, end);
    },
    paginatedAllOverlaps(){
      const current_page = this.paginationParams.allOverlaps.current_page;
      const perPageCount = this.paginationParams.allOverlaps.perPageCount;
      const start = (current_page - 1) * perPageCount;
      const end = current_page * perPageCount;
      return this.OverlapTableData.AllOverlaps.slice(start, end);
    },
    paginatedperCharger(){
      const current_page = this.paginationParams.perCharger.current_page;
      const perPageCount = this.paginationParams.perCharger.perPageCount;
      const start = (current_page - 1) * perPageCount;
      const end = current_page * perPageCount;
      return this.OverlapTableData.OverlapPerCharger.slice(start, end);
    }
  },
  watch: {
    loadingProp: {
      handler: function (newValue) {
        this.loading = newValue;
      },
      deep: true,
    },
    usersDataProp: {
      handler: function (newValue) {
        // this.filterSession = newValue;
        this.OverlapTableData.OverlapPerCharger = newValue.overlapPerCharger;
        this.OverlapTableData.AllOverlaps = newValue.allOverlaps;
        this.OverlapTableData.OverlapPairs = newValue.overlapPairs;

        this.paginationParams.pairs.total_items = newValue.overlapPairs.length;
        this.paginationParams.allOverlaps.total_items = newValue.allOverlaps.length;
        this.paginationParams.perCharger.total_items = newValue.overlapPerCharger.length;

        this.paginationParams.pairs.perPageCount = 50;
        this.paginationParams.allOverlaps.perPageCount = 50;
        this.paginationParams.perCharger.perPageCount = 50;

        this.paginationParams.pairs.current_page = 1;
        this.paginationParams.allOverlaps.current_page = 1;
        this.paginationParams.perCharger.current_page = 1;
      },
      deep: true,
    },
    "paginationParams.pairs.perPageCount": function (newVal) {
      this.paginationParams.pairs.current_page = 1;
      this.paginationParams.pairs.perPageCount = parseInt(newVal);
      },
    "paginationParams.allOverlaps.perPageCount": function (newVal) {
      this.paginationParams.allOverlaps.current_page = 1;
      this.paginationParams.allOverlaps.perPageCount = parseInt(newVal);
    },
    "paginationParams.perCharger.perPageCount": function (newVal) {
      this.paginationParams.perCharger.current_page = 1;
      this.paginationParams.perCharger.perPageCount = parseInt(newVal);
    },

  },
  methods: {
    changePage(type, page) {
        if(type === 'pairs') this.paginationParams.pairs.current_page = page;
        if(type === 'allOverlaps') this.paginationParams.allOverlaps.current_page = page;
        if(type === 'perCharger') this.paginationParams.perCharger.current_page = page;
        // this.paginationParams.pairs.current_page = page;
      },
    updatePageSize(type, size) {
        if(type === 'pairs') {
          this.paginationParams.pairs.perPageCount = size;
          this.paginationParams.pairs.current_page = 1;
        }
        if(type === 'perCharger') {
          this.paginationParams.perCharger.perPageCount = size;
          this.paginationParams.perCharger.current_page = 1;
        }
        if(type === 'allOverlaps') {
          this.paginationParams.allOverlaps.perPageCount = size;
          this.paginationParams.allOverlaps.current_page = 1;
        }
      },
    convertLabelNames(str) {
      return convertToTitleCase(str);
    },

    // handleShow(index, data) {
    //   this.$emit("tableAction", { index: index, data: data, kind: "edit" });
    // },

    formatDate(date, format) {
      if (date != null && date != "") return moment(date).format(format);
      else return null;
    },
  },
};
</script>